import styled from "styled-components";
import {
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_RB_PURPLE_100,
	COLOR_RB_PURPLE_300,
} from "@website-builder/utilities-index";

export const ReachUsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 90px;
	p {
		margin: 0px;
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		margin-top: -10px;
		margin-bottom: 90px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-top: -20px;
		margin-bottom: 70px;
	}
`;

export const Header = styled.h2`
	width: 620px;
	font-size: 26px;
	font-weight: ${FONT_WT_MEDIUM};
	text-align: center;
	margin: 0px;
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 300px;
		font-size: 24px;
		line-height: 1.29;
	}
`;

export const Description = styled.span`
	width: 370px;
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	text-align: center;
	margin: 15px 0px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 240px;
		font-size: 16px;
		line-height: 1.69;
		margin: 25px 0px 0px;
	}
`;

export const Phone = styled.span`
	width: 620px;
	font-size: 20px;
	font-weight: ${FONT_WT_MEDIUM};
	text-align: center;
	margin: 10px 0px 0px 0px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: none;
	}
`;

export const PhoneMobile = styled.a`
	display: none;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 150px;
		height: 51px;
		border-radius: 3px;
		border: 1px solid ${COLOR_RB_PURPLE_300};
		text-decoration: none;
		margin: 22px 0px 0px 0px;
		p {
			font-size: var(--fs-1, 14px);
			font-weight: 600;
			text-align: center;
			color: ${COLOR_RB_PURPLE_300};
		}
		&:hover {
			background-color: ${COLOR_RB_PURPLE_100};
			border-color: ${COLOR_RB_PURPLE_100};
			color: ${COLOR_RB_PURPLE_300};
		}
	}
`;
